module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "dedication1"
  }, [_vm._v("To the memory"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("of")]), _vm._v(" "), _c('p', {
    staticClass: "dedication3"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("R.123313 Flight Sergeant Kenneth Earl Clifford Slack RCAF,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("433 (Porcupine) Squadron, Royal Canadian Air Force,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("who, aged 21, gave his life on 8 May 1945 whilst")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("trying to save a German guard from drowning")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("in the River Elbe near Schönebeck,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("and to the hundreds of his fellow prisoners-of-war")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("who also should have returned home.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication4"
  }, [_vm._v("‘Lives of great men all remind us"), _c('br'), _vm._v("We can make our lives sublime,"), _c('br'), _vm._v("And, departing, leave behind us"), _c('br'), _vm._v("Footprints on the sands of time.’")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("H.W. Longfellow (1807-1882)"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d597cf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 66
// module chunks = 0